global.apiUrl = "https://admin.indussalvage.com";